import { Switch } from '@arco-design/web-react'
import type { OptionsAPI } from './useOptions'

interface Props {
  options: OptionsAPI
  optionKey: string
  checked?: boolean
  defaultChecked?: boolean
  disabled?: boolean
}

/** 开关变更后立即 PUT 单键（对齐 newapi 系统设置即时保存） */
export default function InstantSwitch({
  options,
  optionKey,
  checked,
  defaultChecked = false,
  disabled,
}: Props) {
  const { getBool, saveOne, saving } = options
  const isChecked = checked ?? getBool(optionKey, defaultChecked)

  return (
    <Switch
      checked={isChecked}
      disabled={disabled || saving}
      onChange={async (v) => {
        await saveOne(optionKey, v)
      }}
    />
  )
}
